// src/components/Gallery.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE } from '../api';

const Gallery = () => {
  const [albums, setAlbums] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAlbums = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/gallery`);
        const data = await res.json();
        if (data.success) {
          setAlbums(data.albums);
        }
      } catch (error) {
        console.error('Error fetching gallery albums:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchAlbums();
  }, []);

  return (
    <main className="bg-white">
      {/* Banner / Hero Section */}
      <section
        className="relative bg-center bg-cover h-72 flex items-center justify-center"
        style={{ backgroundImage: "url('/images/gallery_banner.jpg')" }}
      >
        <div className="bg-black bg-opacity-40 absolute inset-0" />
        <div className="relative z-10 text-center text-white">
          <h1 className="text-4xl font-bold">Our Photos</h1>
        </div>
      </section>

      {/* Main Gallery Section */}
      <section id="portfolio" className="py-16">
        <div className="container mx-auto px-4">
          {/* Section Header */}
          <div className="mb-8 text-center">
            <p className="text-dark">
              <span className="text-secondary mr-2">Check our</span>
            </p>
            <h1 className="text-3xl font-bold text-primary">Gallery</h1>
          </div>

          {loading ? (
            <p className="text-center text-gray-500">Loading gallery...</p>
          ) : albums.length === 0 ? (
            <p className="text-center text-gray-500">No albums available.</p>
          ) : (
            <div className="flex flex-col md:flex-row justify-center gap-12">
              {albums.map((album) => (
                <Link
                  key={album._id}
                  to={`/gallery/${album.slug}`}
                  className="block group w-full md:w-1/3 transform hover:scale-105 transition-transform"
                >
                  <div className="bg-white p-4 rounded shadow hover:shadow-lg transition-shadow">
                    {album.coverImage ? (
                      <img
                        src={`${API_BASE}/${album.coverPath}`}
                        alt={album.title}
                        className="w-full h-56 object-cover"
                      />
                    ) : (
                      <div className="w-full h-56 bg-gray-200 flex items-center justify-center text-gray-400">
                        No Cover
                      </div>
                    )}
                    <div className="mt-2 text-center text-dark font-semibold text-lg">
                      {album.title}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default Gallery;
